module.exports = __webpack_public_path__ + "img/1420869134.80c866b8.jpg";